<template>
  <div :class="$style.root">
    <RotatedHeading>
      <h3>Наши работы</h3>
    </RotatedHeading>

    <div :class="$style.wrapper">
      <BaseSlider
        ref="slick"
        :is-manual-sliding="true"
        :options="sliderOpts"
      >
        <div
          v-for="(project, index) in projectsSlides"
          :key="index"
          :class="$style.projectSlideWrapper">
          <div :class="$style.projectSlide">
            <app-image
              :class="$style.picture"
              :x1="project.thumbnail.x1"
              :x2="project.thumbnail.x2"
              :webp="project.thumbnail.webp"
              :alt="project.name"
            />
            <div :class="$style.desc">
              <p :class="$style.title">
                {{ project.name }}
              </p>
              <p :class="$style.text">
                {{ project.shortDescription }}
              </p>
              <router-link
                :class="$style.button"
                :to="`/projects/${project.slug}`">
                Подробнее
              </router-link>
            </div>
          </div>
        </div>
      </BaseSlider>
    </div>

  </div>
</template>
<script>
import RotatedHeading from 'components/RotatedHeading';
import BaseSlider from 'components/BaseSlider';
import { projectsSlides } from 'data/mockProjects';

export default {
  name: 'HomeCases',
  components: {
    RotatedHeading,
    BaseSlider,
  },
  data() {
    return {
      projectsSlides,
      sliderOpts: {
        dots: false,
        arrows: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dotsClass: this.$style.sliderDots,
        prevArrow: `<button type="button" class="${this.$style.sliderArrow}
          ${
            this.$style.sliderArrowLeft
          }" tabindex="0"><i class="el-icon-arrow-left"></i></button>`,
        nextArrow: `<button type="button" class="${this.$style.sliderArrow}
          ${
            this.$style.sliderArrowRight
          }" tabindex="0"><i class="el-icon-arrow-right"></i></button>`,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: true,
              draggable: true,
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" module>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/helpers';

.root {
  @extend %container;
  @extend %section;

  @include media('<tablet') {
    padding-top: 0;
  }
}

.wrapper {
  @extend %content;

  position: relative;

  @include media('<tablet') {
    margin-left: -$grid-gutter;
    margin-right: -$grid-gutter;
  }

  [class*='slick-slider'] {
    margin-right: -15%;

    @include media('<tablet') {
      margin-right: 0;
    }

    ul li button {
      width: 8px;
      height: 8px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      outline: none;
      font-size: 0;
      background-color: $dots-color;
    }

    ul li[class*='slick-active'] button {
      background-color: $dots-active-color;
    }
  }
}

.projectSlideWrapper {
  //padding: 0 0 15px 15px;
  padding: 0 30% 35px 35px;

  @include media('<desktop-xlg') {
    padding: 0 15% 35px 35px;
  }

  @include media('<desktop-lg') {
    padding: 0 13% 35px 35px;
  }

  @include media('<desktop') {
    padding: 0 14% 35px 35px;
  }

  @include media('<tablet') {
    padding: 0;
  }
}

.projectSlide {
  position: relative;
}

.picture {
  box-shadow: -35px 35px 0 0 #f0f0f0;
  display: block;
  width: 100%;

  @include media('<tablet') {
    box-shadow: none;
  }
}

.desc {
  $shadow: rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  text-align: center;
  padding: 0 10px;

  @include media('>=tablet') {
    width: 392px;
    padding: 64px 28px 58px;
    border: 1px solid #eee;
    box-shadow: 0 1px 15px 0 $shadow;
    background-color: $white;
    transform: translateY(-50%);
    position: absolute;
    top: 50%;
    right: -20%;
  }

  @include media('<desktop-xlg') {
    right: -3%;
  }

  @include media('<desktop-lg') {
    right: 10%;
  }

  @include media('<tablet') {
    margin-top: 40px;
  }
}

.title {
  @extend %heading;

  @include media('<tablet') {
    margin-bottom: 20px;
  }
}

.text {
  margin: 0 0 39px;
  padding: 0;
  font-size: 16px;
  line-height: 1.56;
  color: $gray-dark;
}

.button {
  @extend %button;
}

.sliderDots {
  @extend %slickDots;
  position: static;
  margin: 10px auto 0;
  transform: none;
}

.sliderArrow {
  border: 0;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 36px;
  width: 36px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background-color: $gray-transparent;
  color: $white;
  position: absolute;
  top: 50%;
  z-index: 10;
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
}

.sliderArrowLeft {
  left: 0;

  @include media('<=phone') {
    left: 20px;
  }
}

.sliderArrowRight {
  right: 15%;

  @include media('<desktop-xlg') {
    right: 12%;
  }

  @include media('<desktop-lg') {
    right: 13%;
  }

  @include media('<tablet') {
    right: 0;
  }

  @include media('<=phone') {
    right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HomeCases.vue